import React from 'react';
import { Icon, Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './styles.css';

export const ErrorFallback = () => {
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <div className={styles.container}>
      <div className={styles.centeredContainer}>
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
      </div>
      <p className={styles.title}>{getMessage('pluginLoad.error')}</p>
      <div className={styles.centeredContainer}>
        <Button mode="primary" onClick={handleRefresh}>{getMessage('common.refresh')}</Button>
      </div>
    </div>
  );
};
